import { createContext, useContext, useEffect, useState } from "react";

const SavedContext = createContext(null);
const KEY = "homio_saved";

export function SavedProvider({ children }) {
  const [saved, setSaved] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setSaved(JSON.parse(raw));
    } catch {}
  }, []);

  const persist = (next) => {
    setSaved(next);
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch {}
  };

  const toggleSave = (property) => {
    const exists = saved.find((s) => s.id === property.id);
    if (exists) {
      persist(saved.filter((s) => s.id !== property.id));
    } else {
      persist([
        ...saved,
        {
          id: property.id,
          slug: property.slug,
          title: property.title,
          price: property.price,
          price_qualifier: property.price_qualifier,
          listing_type: property.listing_type,
          rental_frequency: property.rental_frequency,
          town: property.town,
          area: property.area,
          bedrooms: property.bedrooms,
          bathrooms: property.bathrooms,
          status: property.status,
          image: property.images?.[0]?.url,
        },
      ]);
    }
  };

  const isSaved = (id) => saved.some((s) => s.id === id);
  const removeSaved = (id) => persist(saved.filter((s) => s.id !== id));

  return (
    <SavedContext.Provider value={{ saved, toggleSave, isSaved, removeSaved }}>
      {children}
    </SavedContext.Provider>
  );
}

export function useSaved() {
  return useContext(SavedContext);
}
